<template>
  <Doughnut
    v-bind:data="data"
    v-bind:options="options"
    v-bind:style="styles" />
</template>
<script>
  import { Doughnut } from 'vue-chartjs';
  import ChartPluginAnnotation from 'chartjs-plugin-annotation';
  import { Chart as ChartJS, Title } from 'chart.js';
  ChartJS.register(ChartPluginAnnotation, Title);

  export default {
    name: 'doughnut-chart',
    components: { Doughnut },
    props: ['chart_data', 'chart_options', 'styles'],
    data() {
      return {
        data: this.chart_data,
        options: {
          responsive: true,
          ...this.chart_options
        }
      };
    }
  };
</script>
